import { Component } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';

import { PieceExternalProviderAppsSettings } from './models/piece-external-provider-apps.models';


@Component({
  selector: 'piece-externalProviderApps-render',
  templateUrl: './piece-external-provider-apps-render.component.html'
})
export class PieceExternalProviderAppsRenderComponent
  extends BaseRenderComponent<PieceExternalProviderAppsSettings> {

  public get providersName() {
    return this.settings.general?.providersName;
  }

  public get apiKey() {
    return this.settings.general?.apiKey;
  }

  public get idBrand() {
    return this.settings.general?.idBrand;
  }

  public get idAlbum() {
    return this.settings.general?.idAlbum;
  }

  public get idWidget01() {
    return this.settings.general?.idWidget01;
  }

  public get idWidget02() {
    return this.settings.general?.idWidget02;
  }

  public get idWidget03() {
    return this.settings.general?.idWidget03;
  }

  public get idWidget04() {
    return this.settings.general?.idWidget04;
  }

  public get idWidget05() {
    return this.settings.general?.idWidget05;
  }

  public get paramWidget01() {
    return this.settings.general?.paramWidget01;
  }

  public get paramWidget02() {
    return this.settings.general?.paramWidget02;
  }

  public get paramWidget03() {
    return this.settings.general?.paramWidget03;
  }

  public get paramWidget04() {
    return this.settings.general?.paramWidget04;
  }

  public get paramWidget05() {
    return this.settings.general?.paramWidget05;
  }

}
